import { ChangeDetectionStrategy, Component, computed, inject, Signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { BottomNavbarComponent, GameCardV2Component, PageLayoutComponent, TitileNavbarComponent } from '@ui-components';
import { ActivatedRoute, Params } from '@angular/router';
import { shareReplay, switchMap, take, tap } from 'rxjs';
import {
  AppRoutes,
  GameDetailsModel,
  MODAL_TOKEN,
  ModalProvider,
  USER_DATA_TOKEN,
  UserDataProvider,
  UserModel
} from '@core';
import { RatingAppComponent } from '../rating-app/rating-app.component';
import { GameDetailsQueryHandler, RateAppCommandHandler } from '../../application/handlers';

@Component({
  selector: 'lib-game-finished',
  templateUrl: './game-finished.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [TitileNavbarComponent, BottomNavbarComponent, RatingAppComponent, GameCardV2Component, PageLayoutComponent],
  providers: [RateAppCommandHandler]
})
export class GameFinishedComponent {
  private readonly gameDetailsQueryHandler: GameDetailsQueryHandler = inject(GameDetailsQueryHandler);
  private readonly activatedRoute: ActivatedRoute = inject(ActivatedRoute);
  private readonly userDataProvider: UserDataProvider = inject(USER_DATA_TOKEN);
  private readonly modalProvider: ModalProvider = inject(MODAL_TOKEN);

  readonly playerText: string =
    'Jeśli nie zapłaciłeś organizatorowi za gierkę, opłać ją za pomocą BLIKA w swoim telefonie.';
  readonly hostText: string = 'Dziękujemy za skorzystanie z Orlikfy!';
  readonly customBackUrl: string = `${AppRoutes.ROOT}`;

  readonly game: Signal<GameDetailsModel | undefined> = toSignal(
    this.modalProvider.showLoading$().pipe(
      switchMap(() => this.activatedRoute.params),
      take(1),
      switchMap((params: Params) => this.gameDetailsQueryHandler.getGameDetails(params['id'])),
      tap(() => this.modalProvider.dismissLoading$()),
      shareReplay(1)
    )
  );

  private readonly userData: Signal<UserModel | undefined> = toSignal(this.userDataProvider.userData$);

  readonly isHostedGame: Signal<boolean> = computed(() => {
    const game: GameDetailsModel | undefined = this.game();
    const userData: UserModel | undefined = this.userData();
    if (!game || !userData) return false;
    return game.host?.hostId === userData.userId;
  });

  readonly messageText: Signal<string> = computed(() => {
    return this.isHostedGame() ? this.hostText : this.playerText;
  });
}
